import styled, { css } from 'styled-components';
import { Box, Avatar } from '@bechtel/gds';
export const ProgressContainerStyled = styled.div`
  ${({ theme }) => css`
    display: grid;
    height: 100vh;
    overflow-y: auto;
    background-color: ${theme.colors.grey[200]};
    grid-template-rows: 55% 45%;
    grid-row-gap: ${theme.spacings[500]};
    padding: ${theme.spacings[500]};
  `}
`;

export const ChildContainerStyled = styled(Box).attrs({
  flexGrow: { sm: '1' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.spacings[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  `}
`;

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;
